import { Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { MatError, MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MatButtonModule } from "@angular/material/button";
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from "@angular/forms";
import { DatePipe } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-about-you-form",
  imports: [MatFormFieldModule, MatDatepickerModule, MatInputModule, MatButtonModule, ReactiveFormsModule, DatePipe, TranslateModule, MatError],
  providers: [provideNativeDateAdapter(), DatePipe],
  templateUrl: "./about-you-form.component.html",
  styleUrl: "./about-you-form.component.scss",
})
export class AboutYouFormComponent implements OnInit {
  @Output() onToggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() formValidity: EventEmitter<any> = new EventEmitter<{
    form: string;
    status: boolean;
  }>();
  @Input() initialValue: any;
  datePipe = inject(DatePipe);
  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      NAME: [""],
      EMAIL: ["", [Validators.required, Validators.email]],
      DATEOFBIRTH: ["", [Validators.required, this.minimumAgeValidator(18)]],
    });
  }

  get email() {
    return this.form.get("EMAIL");
  }

  get dateOfBirth() {
    return this.form.get("DATEOFBIRTH");
  }

  ngOnInit() {
    this.form.setValue({
      NAME: this.initialValue?.NAME || "",
      EMAIL: this.initialValue?.EMAIL || "",
      DATEOFBIRTH: this.initialValue?.DATEOFBIRTH || "",
    });
    this.setFormValidity();
    this.form.valueChanges.subscribe((value) => {
      this.setFormValidity();
      this.onChange.emit({
        ...value,
        DATEOFBIRTH: this.datePipe.transform(value.DATEOFBIRTH, "yyyy-MM-dd"),
      });
    });
  }

  // Custom Validator for Minimum Age
  minimumAgeValidator(minAge: number) {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null; // No validation error if the field is empty
      }

      const today = new Date();
      const dob = new Date(value);
      const age = today.getFullYear() - dob.getFullYear();

      // Check if the user has already had their birthday this year
      const isOldEnough = age > minAge || (age === minAge && today >= new Date(dob.setFullYear(dob.getFullYear() + minAge)));

      return isOldEnough ? null : { underage: { requiredAge: minAge, actualAge: age } };
    };
  }

  setFormValidity() {
    this.formValidity.emit({ form: "about-you", status: this.form.valid });
  }
}
